/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'linkedin': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" d="M0 5h3v11H0zM11 5C9.14 5 8.42 6 7.96 7L8 5H5.03C5.08 6 5 16 5 16h3v-5.85c0-.3.02-.62.1-.84.25-.62 1.01-1.27 1.97-1.27C11.31 8.04 12 9 12 10.4V16h3v-6c0-3.21-1.74-5-4-5z"/><circle pid="1" cx="1.5" cy="2.5" r="1.5" _fill="currentColor"/>'
  }
})
